import type { ReactNode } from 'react';
import { useState } from 'react';

import { ReactINTLProvider } from '@picsart/rc/services/localization';
import useMount from 'hooks/common/useMount.ts';
import { getContext } from 'configs/context';

interface INTLProviderProps {
  children: ReactNode;
}

const INTLProvider = ({ children }: INTLProviderProps) => {
  const [language, setLanguage] = useState(getContext().general.language.getState());

  useMount(() => {
    getContext().general.language.subscribe(nextLanguage => setLanguage(nextLanguage));
  });

  return (
    <ReactINTLProvider projectName="pa_miniapps" language={language}>
      {children}
    </ReactINTLProvider>
  );
};

export default INTLProvider;
